var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    { staticClass: "c-rap-upload-box-wrapper" },
    [
      _c("legend", [
        _vm.title
          ? _c("h3", { staticClass: "c-rap-upload-box__title" }, [
              _vm._v(_vm._s(_vm.title))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "c-rap-upload-box__intro",
        domProps: { innerHTML: _vm._s(_vm.intro) }
      }),
      _vm._v(" "),
      _c(
        "validation-message",
        {
          attrs: {
            valid: _vm.files.length && !_vm.extensionError && !_vm.nameError,
            invalid: _vm.extensionError || _vm.nameError,
            validationMessage: _vm.extensionError
              ? _vm.errorMessage("extension")
              : null
          }
        },
        [
          _vm._l(_vm.files, function(file) {
            return _c(
              "div",
              { key: file.id, staticClass: "c-rap-upload-box__wrapper" },
              [
                _c("div", { staticClass: "c-rap-upload-box__file" }, [
                  _c("span", { staticClass: "c-rap-upload-box__name" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(file.name) +
                        " (" +
                        _vm._s(_vm._f("formatFileSize")(file.size)) +
                        ")\n          "
                    )
                  ]),
                  _vm._v(" "),
                  file.error
                    ? _c("span", { staticClass: "c-rap-upload-box__status" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errorMessage(file.error)) +
                            "\n          "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.extensionError
                    ? _c("span", { staticClass: "c-rap-upload-box__status" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errorMessage("extension")) +
                            "\n          "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.nameError
                    ? _c("span", { staticClass: "c-rap-upload-box__status" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errorMessage("name")) +
                            "\n          "
                        )
                      ])
                    : file.success
                      ? _c(
                          "span",
                          { staticClass: "c-rap-upload-box__status" },
                          [_vm._v("\n            Done\n          ")]
                        )
                      : file.active || file.progress !== "0.00"
                        ? _c(
                            "span",
                            {
                              staticClass: "c-rap-upload-box__progress",
                              attrs: {
                                "aria-valuemax": "100",
                                "aria-valuemin": "0",
                                "aria-valuenow": file.progress
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "c-rap-upload-box__progress-bar",
                                  style: { width: file.progress + "%" },
                                  attrs: { role: "progressbar" }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(file.progress) +
                                      "%\n            "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "c-rap-upload-box__actions" }, [
                  !file.success && !_vm.extensionError
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "c-button c-button--brand c-button--text-center",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.$refs.upload.update(file, {
                                active: true
                              })
                            }
                          }
                        },
                        [_vm._v("\n            Upload\n          ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !file.success
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "c-button c-button--brand c-button--text-center",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.removeUpload(file)
                            }
                          }
                        },
                        [_vm._v("\n            Reset\n          ")]
                      )
                    : _vm._e()
                ])
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.files.length,
                  expression: "!files.length"
                }
              ],
              staticClass: "c-rap-upload-box__drag-drop"
            },
            [
              _c("div", { staticClass: "c-rap-upload-box__container" }, [
                _c("span", [_vm._v("Please either drag a file here or")]),
                _vm._v(" "),
                _c("div", { staticClass: "c-rap-upload-box" }, [
                  _c(
                    "label",
                    {
                      staticClass:
                        "c-button c-button--link c-rap-upload-box__label",
                      attrs: { for: _vm.inputId }
                    },
                    [
                      _c("file-upload", {
                        ref: "upload",
                        staticClass: "visually-hidden",
                        attrs: {
                          drop: _vm.drop,
                          "drop-directory": _vm.dropDirectory,
                          "input-id": _vm.inputId,
                          multiple: _vm.multiple,
                          name: _vm.inputId,
                          "post-action": _vm.uploadPostAction,
                          size: _vm.size
                        },
                        on: {
                          "input-filter": _vm.inputFilter,
                          "input-file": _vm.inputFile
                        },
                        model: {
                          value: _vm.files,
                          callback: function($$v) {
                            _vm.files = $$v
                          },
                          expression: "files"
                        }
                      }),
                      _vm._v(
                        "\n            choose a file to upload\n          "
                      )
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dfcceb2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dfcceb2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/_contact-us-rap/_vue/UploadBox.vue
// module id = 717
// module chunks = 0